"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = __importDefault(require("@graphql-mesh/openapi"));
const OPENAPI_SPECIFICATION = 'http://resources.docs.salesforce.com/rel1/doc/en-us/static/misc/iot-connect-api-swagger-45.0.yaml';
class SalesforceHandler extends openapi_1.default {
    constructor({ name, config, cache, pubsub, }) {
        config.source = OPENAPI_SPECIFICATION;
        if (config.token) {
            config.schemaHeaders = config.operationHeaders = {
                Authorization: `Bearer ${config.token}`,
            };
        }
        super({ name, config, cache, pubsub });
    }
}
exports.default = SalesforceHandler;
//# sourceMappingURL=handler.js.map